// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"f06b1139","341":"9a5540a4","551":"6b8b34a2","583":"65d51f6c","706":"47698300","787":"ebc8675a","897":"e1acaf0c"}[chunkId] + ".chunk.css";
};